<script setup lang="ts">
import { computed } from 'vue';
import { ToggleButton } from '@hfc/ui-core';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

interface EmitInterface {
  (event: 'change'): void
}

defineProps<{
  size?: 'sm' | 'md' | 'lg'
  onLabelClass?: string
  offLabelClass?: string
}>();

const emits = defineEmits<EmitInterface>();

const { smallBusinessStore, smallBusinessState } = useSmallBusinessStore();

const calChoice = computed(() => !!smallBusinessState.value.application.filters?.cal_choice);

const updateCalChoice = async (value: boolean): Promise<void> => {
  await smallBusinessStore.setCalChoiceFilter(value);
  emitChanges();
};

const emitChanges = (): void => {
  emits('change');
};
</script>
<template>
  <div class="flex flex-col w-full">
    <ToggleButton v-model="calChoice" on-label="CovCal" on-label-tooltip="Covered California" off-label="CalChoice" off-label-tooltip="California Choice" :on-label-class="onLabelClass" :off-label-class="offLabelClass" :size="size" @change="(val: boolean) => updateCalChoice(val)" />
  </div>
</template>
